import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import SingleCollectionPage from './SingleNew/SingleCollectionPage';
import BulkCollection from './Bulk/BulkCollectionContainer';
import GroupCreation from '../Groups/CreateGroup/GroupCreationContainer';
import EditGroup from '../Groups/EditGroup/EditGroupContainer';
import GroupDetails from '../Groups/GroupDetails/GroupDetailsContainer';
import { usePermissions } from '../../providers/Permissions.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { JSX } from 'react';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';

const Routes = (): JSX.Element => {
  const { permissions } = usePermissions();
  const featureFlags = useModuleFeatureFlag('collection');
  const lockedFeatures = useLockedFeatures();
  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkCollections && !!lockedFeatures.CollectionsEnabled}
        showPermission
        path="/bulk-collection"
        exact
        component={BulkCollection}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkCollections && !!lockedFeatures.CollectionsEnabled}
        showPermission
        path="/bulk-collection/group/:GroupID"
        exact
        component={GroupDetails}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkCollections && !!lockedFeatures.CollectionsEnabled}
        showPermission
        path="/bulk-collection/create"
        exact
        component={GroupCreation}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && featureFlags.BulkCollections && !!lockedFeatures.CollectionsEnabled}
        showPermission
        path="/bulk-collection/edit/:GroupID"
        exact
        component={EditGroup}
      />

      <ProtectedRoute
        isAllowed={!!permissions.CreateCollections && featureFlags.isEnabled && !!lockedFeatures.CollectionsEnabled}
        showPermission
        exact
        path="/single-collection"
        component={SingleCollectionPage}
      />
    </Switch>
  );
};

export default Routes;
